import { useQuery } from '@tanstack/react-query';
import secureLocalStorage from 'react-secure-storage';

import { serverRequest } from "../../../util/server_request";
import { extractErrorMessage } from '../../extractErrorMessage';
import { notifyUser } from '../../../util/util';

const notifiedErrors = new Set();

// Helper function to notify only once for the same error
const notifyOnce = (type, message, title = "") => {
  if (!notifiedErrors.has(message)) {
    notifiedErrors.add(message);
    notifyUser(type, message, title);
  }
};

// Fetches corporate transactions from /corporate-transactions endpoint using React Query
export function useCorporateTransactions(policyNumber, enabled = true) {
  return useQuery({
    queryKey: ['corporate-transactions', policyNumber],
    queryFn: async () => {
      try {
        const params = new URLSearchParams({
          limit: '100', // or whatever default
          date_from: '2020-01-01',
          date_to: new Date().toISOString().split('T')[0], // today
        });
        if (policyNumber) {
          params.append('policy_no', policyNumber);
        }
        const result = await serverRequest('GET', `corporate-transactions?${params.toString()}`);
        if (!result || !result.success) {
          throw new Error(result?.message || 'Failed to fetch corporate transactions');
        }
        return result.data.claim_payment || [];
      } catch (error) {
        const errorMessage = extractErrorMessage(error, 'Failed to fetch corporate transactions');
        notifyOnce("error", errorMessage, "Error");
        throw new Error(errorMessage);
      }
    },
    enabled: enabled && !!secureLocalStorage.getItem('token'),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}